export const weight_verified_scale_values = [{id: 0, name: "Un specified"}, 
                                      {id: 1, name: "true"},
                                      {id: 2, name: "false"}]